import { combineReducers } from 'redux'

import settings from './settings';
import notification from './notification';

const settingsReducers = combineReducers({
    settings,
    notification
});

export default settingsReducers;



// WEBPACK FOOTER //
// ./src/UserSettings/reducers/index.js